import { AskRequest, ReportConfiguration, SummaryItem } from '@hone-automation/common';
import Queue from '../Queue';
import './Dashboard.scss';
import { prefixClass } from 'lib/utils';
import DashboardCardList from './DashboardListGroup/DashboardCardList';
import { useEffect, useMemo, useState } from 'react';
import KSChart from '../KSChart/KSChart';
import { useLocationsStore } from 'hooks/useLocationsStore';
import { shallow } from 'zustand/shallow';
import { useTemplatesRangesQuery } from 'hooks/reports/useTemplatesRangesQuery';
import reportToDashboard from './DParser/reportToDashboard';
import { useDashboardReport } from './useDashboardReport';
import classNames from 'classnames';
import { useAuthContext } from 'context/useAuthContext';

// TO-DO replace this import with the one on hone-automation/common
import { ChartMetrics, metricsPeriodPlot, MetricsPlot } from './DParser/types';
import { logger } from '../KSExport/reportNTParser/utils';
import { useReportsStore } from 'hooks/useReportsStore';
import { useGetReportConfiguration } from '../../../hooks';
import { getPeriodsWeeksChartData } from './DParser/DPeriodStructure';
import { GetReportsConfig } from 'domain/usecases/reports/get-reports-config';
import { useDashboardChartDataQuery } from 'hooks/useDashboardChartDataQuery';
import { forEach } from 'lodash';
import { calculatePeriodMetrics } from '../KSChart/periodMetricsCalculator';
import { IconChartDashboard } from 'components/Icons';
import { Tooltip, Whisper } from 'rsuite';

const Dashboard = () => {
  const prefix = prefixClass('dashboard');
  const trace = false;
  const { user } = useAuthContext();
  const [menu, setMenu] = useState<'Opportunities' | 'Requests'>('Requests');
  const [readReport, setReadReport] = useState(false);
  const [chartData, setChartData] = useState<MetricsPlot>({ periodReporting: true, periods: [], metrics: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [leftPane, setLeftPane] = useState(true);

  // Reading chart data from BE
  const { data: chartBEData } = useDashboardChartDataQuery();

  /* 

      *** Reading current location report from store
      It's used if the BE is returning a chart that does not have ChartMetrics in the template
      To be removed once BE and Opportunities (LLM proccesing) is Ready
  */
  const { currentLocationId, currentLocation } = useLocationsStore(
    state => ({ currentLocationId: state.currentLocationId, currentLocation: state.currentLocation }),
    shallow
  );

  const { data: reportConfiguration } = useGetReportConfiguration(currentLocationId);
  const { data: availableTemplates } = useTemplatesRangesQuery();
  const templateId = availableTemplates?.[0]?.id || '';

  // @ts-ignore
  const periodStructure = getPeriodsWeeksChartData(currentLocation?.weekStart, reportConfiguration?.data, 6);
  const COMPARISON_PERIODS = periodStructure.completeWeeks;
  const { reportData } = useDashboardReport(
    currentLocation!,
    templateId,
    availableTemplates!,
    COMPARISON_PERIODS,
    readReport
  );
  /* 
      *** All above is needed to read the report and compile it

  */

  useEffect(() => {
    if (chartBEData !== undefined) {
      setMenu('Requests');
      setIsLoading(false);
      if (!chartBEData?.metrics?.length) {
        setReadReport(true);
      } else {
        if (trace) logger.msg('chartData from BE ->', chartBEData);
        // @ts-ignore
        setChartData(chartBEData);
        setReadReport(false);
      }
    }
  }, [chartBEData]);

  useEffect(() => {
    if (!chartBEData || !reportData) return;
    if (trace) {
      logger.msg('reportData extracted from Report', reportData);
      logger.msg('reportConfiguration', reportConfiguration);
      logger.msg('periodStructure', periodStructure);
    }
    const { chartData: newChartData } = reportToDashboard(reportData, periodStructure, trace);
    if (trace) logger.msg('newChartData', newChartData);
    if (readReport) setChartData(newChartData);
  }, [readReport, chartBEData, reportData]);

  return (
    <>
      <Whisper
        placement="right"
        delayClose={100}
        delayOpen={800}
        trigger="hover"
        speaker={<Tooltip>{leftPane ? 'Hide Left Pane' : 'Show Left Pane'}</Tooltip>}
      >
        <div className="chart-switch" onClick={() => setLeftPane(!leftPane)}>
          <IconChartDashboard />
        </div>
      </Whisper>
      <div className={prefix()}>
        <div className={classNames(prefix('left-pane'), { 'left-pane-hidden': !leftPane })}>
          <div className={prefix('left-pane__cards-container')}>
            <DashboardCardList onChange={(menu: 'Opportunities' | 'Requests') => setMenu(menu)} selected={menu} />
          </div>
          <div className={prefix('left-pane__chart-container')}>
            <KSChart data={chartData} customHeight={320} />
          </div>
        </div>
        <div className={prefix('right-pane')}>
          <div className={classNames(prefix('right-pane__title'), { 'left-pane-hidden': !leftPane })}>{menu}</div>
          <div className={prefix('right-pane__view-area')}>
            <div className={classNames(prefix('right-pane__view-area-slider'), { 'slider-move': menu === 'Requests' })}>
              {!isLoading && (
                <>
                  <div className={prefix('right-pane__view-area-slider-component')}></div>
                  <div className={prefix('right-pane__view-area-slider-component')}>
                    <Queue visible={menu === 'Requests'} fullScreen={!leftPane} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
